import { render } from "./PrintInvoiceContactDetailsDesign2.vue?vue&type=template&id=758a0b4e&scoped=true"
import script from "./PrintInvoiceContactDetailsDesign2.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceContactDetailsDesign2.vue?vue&type=script&lang=js"

import "./PrintInvoiceContactDetailsDesign2.vue?vue&type=style&index=0&id=758a0b4e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758a0b4e"]])

export default __exports__